// extracted by mini-css-extract-plugin
module.exports = {"group":"GroupCellByLineName_group__SVjiP","groupLineName":"GroupCellByLineName_groupLineName__2JyVK","groupEmployeesCount":"GroupCellByLineName_groupEmployeesCount__2e_AB"};